/* eslint-disable no-unused-vars */
import {
  encodeQueryData,
  isEmpty,
} from '@/utilities/helpers';
import axios from '../../config/axios';

export const screening = {
  namespaced: true,
  state: {
    screeningData: [],
    screeningIndex: 0,
    familyData: {},
    hereditary: {},
    individualDisease: {},
    imunization: [],
    masterImunization: [],
    icons: {},
  },
  getters: {
  },
  mutations: {
    SET_SCREENING_DATA(state, payload) {
      state.screeningData = payload;
    },
    SET_SCREENING_INDEX(state, payload) {
      state.screeningIndex = payload;
    },
    SET_FAMILY_DATA(state, payload) {
      state.familyData = payload;
    },
    SET_HEREDITARY(state, payload) {
      state.hereditary = payload;
    },
    SET_INDIVIDUAL_DISEASE(state, payload) {
      state.individualDisease = payload;
    },
    SET_IMUNIZATION(state, payload) {
      state.imunization = payload;
    },
    SET_MASTER_IMUNIZATION(state, payload) {
      state.masterImunization = payload;
    },
    SET_ICONS(state, payload) {
      state.icons = payload;
    },
  },
  actions: {
    async getScreeningData({ commit, dispatch }, query) {
      dispatch('global/setLoading', true, { root: true });

      const queries = (!isEmpty(query) && `${encodeQueryData(query)}`) || '';
      const url = `v1/apps/screening-results?${queries}`;

      try {
        const res = await axios({
          url,
          method: 'get',
          headers: {
            'Accept-Language': 'id',
          },
        });

        if (res) {
          commit('SET_SCREENING_DATA', res.data.data);
          dispatch('global/setLoading', false, { root: true });

          return true;
        }
        dispatch('global/setLoading', false, { root: true });
      } catch (err) {
        dispatch('global/setLoading', false, { root: true });
        if (err.response) {
          if (err.response.status === 404) {
            return false;
          }
          dispatch('global/setError', { status: true, err }, { root: true });
          return '';
        }
      }
    },
    setScreeningIndex({ commit }, val) {
      commit('SET_SCREENING_INDEX', val);
    },
    async getFamilyData({ commit, dispatch }, query) {
      dispatch('global/setLoading', true, { root: true });

      const queries = (!isEmpty(query) && `${encodeQueryData(query)}`) || '';
      const url = `v1/apps/screening-results/family-member?${queries}`;

      try {
        const res = await axios({
          url,
          method: 'get',
          headers: {
            'Accept-Language': 'id',
          },
        });

        if (res) {
          commit('SET_FAMILY_DATA', res.data.data);
          dispatch('global/setLoading', false, { root: true });

          return res.data.data;
        }
        dispatch('global/setLoading', false, { root: true });
      } catch (err) {
        dispatch('global/setLoading', false, { root: true });
        if (err.response) {
          dispatch('global/setError', { status: true, err }, { root: true });
          return false;
        }
      }
    },
    async getHereditaryDisease({ commit, dispatch }, query) {
      dispatch('global/setLoading', true, { root: true });

      const queries = (!isEmpty(query) && `${encodeQueryData(query)}`) || '';
      const url = `v1/apps/screening-results/hereditary-disease?${queries}`;

      try {
        const res = await axios({
          url,
          method: 'get',
          headers: {
            'Accept-Language': 'id',
          },
        });

        if (res) {
          commit('SET_HEREDITARY', res.data.data);
          dispatch('global/setLoading', false, { root: true });

          return true;
        }
        dispatch('global/setLoading', false, { root: true });
      } catch (err) {
        dispatch('global/setLoading', false, { root: true });
        if (err.response) {
          dispatch('global/setError', { status: true, err }, { root: true });
          return false;
        }
      }
    },
    async getIndividualDisease({ commit, dispatch }, query) {
      dispatch('global/setLoading', true, { root: true });

      const queries = (!isEmpty(query) && `${encodeQueryData(query)}`) || '';
      const url = `v1/apps/screening-results/individual-disease?${queries}`;

      try {
        const res = await axios({
          url,
          method: 'get',
          headers: {
            'Accept-Language': 'id',
          },
        });

        if (res) {
          commit('SET_INDIVIDUAL_DISEASE', res.data.data);
          dispatch('global/setLoading', false, { root: true });

          return true;
        }
        dispatch('global/setLoading', false, { root: true });
      } catch (err) {
        dispatch('global/setLoading', false, { root: true });
        if (err.response) {
          dispatch('global/setError', { status: true, err }, { root: true });
          return false;
        }
      }
    },
    async getImunization({ commit, dispatch }, query) {
      dispatch('global/setLoading', true, { root: true });

      const queries = (!isEmpty(query) && `${encodeQueryData(query)}`) || '';
      const url = `v1/apps/screening-results/imunization?${queries}`;

      try {
        const res = await axios({
          url,
          method: 'get',
          headers: {
            'Accept-Language': 'id',
          },
        });

        if (res) {
          commit('SET_IMUNIZATION', res.data.data);
          dispatch('global/setLoading', false, { root: true });

          return res.data.data;
        }
        dispatch('global/setLoading', false, { root: true });
      } catch (err) {
        dispatch('global/setLoading', false, { root: true });
        if (err.response) {
          dispatch('global/setError', { status: true, err }, { root: true });
          return [];
        }
      }
    },
    async getMasterImunization({ commit, dispatch }, lifeStage) {
      console.log(lifeStage);
      dispatch('global/setLoading', true, { root: true });
      let type = 'anak_anak,remaja';
      if (lifeStage === 'bayi' || lifeStage === 'balita') type = 'bayi,balita';
      const url = `v1/apps/imunization?group=${type}`;

      try {
        const res = await axios({
          url,
          method: 'get',
          headers: {
            'Accept-Language': 'id',
          },
        });

        if (res) {
          commit('SET_MASTER_IMUNIZATION', res.data.data);
          dispatch('global/setLoading', false, { root: true });

          return res.data.data;
        }
        dispatch('global/setLoading', false, { root: true });
      } catch (err) {
        dispatch('global/setLoading', false, { root: true });
        if (err.response) {
          dispatch('global/setError', { status: true, err }, { root: true });
          return [];
        }
      }
    },
    async getIcons({ commit, dispatch }) {
      dispatch('global/setLoading', true, { root: true });

      const url = 'v1/apps/config/screening-icon';

      try {
        const res = await axios({
          url,
          method: 'get',
          headers: {
            'Accept-Language': 'id',
          },
        });

        if (res) {
          commit('SET_ICONS', res.data.data);
          dispatch('global/setLoading', false, { root: true });

          return res.data.data;
        }
        dispatch('global/setLoading', false, { root: true });
      } catch (err) {
        dispatch('global/setLoading', false, { root: true });
        if (err.response) {
          dispatch('global/setError', { status: true, err }, { root: true });
          return {};
        }
      }
    },
  },
};
